import type { ColumnDef, ColumnSort, OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { TestTemplate } from "@/graphql/codegen/graphql"

interface TestTemplatesTableProps {
  data: TestTemplate[]
  fetching: boolean
  columns: ColumnDef<TestTemplate>[]
  sorting: ColumnSort[]
  error?: Error
  tableContainerRef?: Ref<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  onScroll: () => void
}

export const TestTemplatesTable: FC<TestTemplatesTableProps> = ({
  data,
  fetching,
  columns,
  sorting,
  error,
  tableContainerRef,
  onSortingChange,
  onScroll,
}) => (
  <AerosBaseTable
    features={{
      table: {
        stickyHeader: true,
      },
      tanstackOptions: {
        data,
        columns,
        state: {
          sorting,
          isLoading: fetching,
        },
        onSortingChange,
        manualSorting: true,
        enableSorting: true,
        enableMultiSort: false,
        enableSortingRemoval: false,
        getCoreRowModel: getCoreRowModel(),
      },
    }}
    error={error}
    slotProps={{
      container: {
        ref: tableContainerRef,
        onScroll,
      },
    }}
    noDataMessage='No test templates found'
  />
)

export default TestTemplatesTable
